import { useEffect } from 'react';

interface SEOHeadProps {
  title: string;
  description: string;
  canonicalUrl?: string;
  ogType?: string;
  ogImage?: string;
  schemaJson?: Record<string, unknown> | Record<string, unknown>[];
}

export default function SEOHead({ title, description, canonicalUrl, ogType = 'website', ogImage, schemaJson }: SEOHeadProps) {
  useEffect(() => {
    const fullTitle = `${title} | 蜜桃传媒`;
    document.title = fullTitle;

    const setMeta = (name: string, content: string, property = false) => {
      const attr = property ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    setMeta('og:title', fullTitle, true);
    setMeta('og:description', description, true);
    setMeta('og:type', ogType, true);
    if (canonicalUrl) {
      setMeta('og:url', canonicalUrl, true);
      let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', canonicalUrl);
    }
    setMeta('twitter:title', fullTitle);
    setMeta('twitter:description', description);
    if (ogImage) {
      setMeta('og:image', ogImage, true);
      setMeta('twitter:image', ogImage);
    }

    if (schemaJson && typeof window !== 'undefined') {
      const existingScripts = document.querySelectorAll('script[data-dynamic-schema]');
      existingScripts.forEach((s) => s.remove());

      const schemas = Array.isArray(schemaJson) ? schemaJson : [schemaJson];
      schemas.forEach((schema) => {
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.setAttribute('data-dynamic-schema', 'true');
        script.textContent = JSON.stringify(schema, null, 2);
        document.head.appendChild(script);
      });
    }
  }, [title, description, canonicalUrl, ogType, ogImage, schemaJson]);

  return null;
}